export default "__VITE_ASSET__nAux3_uH__"